import { render, staticRenderFns } from "./RecentlyAddedSeries.vue?vue&type=template&id=c292bada&"
import script from "./RecentlyAddedSeries.vue?vue&type=script&lang=js&"
export * from "./RecentlyAddedSeries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports